// extracted by mini-css-extract-plugin
export default {"container":"S04_container__W997C","limiter":"S04_limiter__lsmPf","guide":"S04_guide__PeJcS"};